const getTemplateOptions = (templates) => {
  return templates?.map((template) => ({
    label: template.title,
    value: template.id,
  })) || [];
};

export default getTemplateOptions;
